import React from 'react';
import withStyles from '@mui/styles/withStyles';

const styles = theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    minHeight: '-webkit-fill-available',
    backgroundColor: theme.palette.background.lightGrey,
  },
});

const Content = ({ classes, children }) => <div className={classes.root}>{children}</div>;

export default withStyles(styles)(Content);
